import templateCompiler from './template.art';

const template = templateCompiler();
export default function EsignCNModule(callback, isOnPremiseDeployMode) {
    if (isOnPremiseDeployMode) {
      let fragments = [];
      return { fragments };
    }
    const esignTab_template =  `<div class="wrapEsignCN hide" name="wrap-esignCN-tab" id="wrap-esignCN-tab">
                                    <gtab text="esign.tabTitle" name="esignCN-tab" group="toolbar-tab" body="fv--esignCN-tab-paddle" @portfolio.unsupport></gtab>
          
                                </div>`
    let ACTIONS = window.UIExtension.UIConsts.FRAGMENT_ACTION;
    let fragments = [
        {
            // 向末尾追加控件
            action: ACTIONS.AFTER,
            // 目标控件名称， 控件将被添加这个空间里面，必须确保它是一个容器类型的控件
            target: 'protect-tab',
            // 定义控件的以及图标，文字等信息
            template: esignTab_template,
        },
        {
            action: ACTIONS.APPEND,
            target: 'toolbar-tab-bodies',
            template: template,
        },
      // {
      //   // to remove 'file-properties' group which is in home tab
      //   action: ACTIONS.REMOVE,
      //   target: FILE_PROPERTIES_GROUP_IN_HOME
      // }
    ];
    return {fragments};
}